import { render, staticRenderFns } from "./UserscriptEditorModal.vue?vue&type=template&id=4a46668c&scoped=true"
import script from "./UserscriptEditorModal.vue?vue&type=script&lang=js"
export * from "./UserscriptEditorModal.vue?vue&type=script&lang=js"
import style0 from "./UserscriptEditorModal.vue?vue&type=style&index=0&id=4a46668c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a46668c",
  null
  
)

export default component.exports